import * as filestack from "filestack-js";
import { useDataContext } from "./dataContext";
import { Upload } from ".././icons";
import { useMantineTheme, Text } from "@mantine/core";
import "./FileSelector.css";

const FileSelector = ({ updateFormField }) => {
  const theme = useMantineTheme();
  const { errors } = useDataContext();

  const API_KEY = import.meta.env.VITE_APP_FILE_STACK_API_KEY;

  const client = filestack.init(API_KEY);

  const handleOpenPicker = () => {
    const options = {
      maxFiles: 10,
      uploadInBackground: false,
      onUploadDone: (res) => {
        const urls = res.filesUploaded.map((file) => ({
          filename: file.filename,
          url: file.url,
        }));

        if (updateFormField) {
          updateFormField("uploadedFiles", urls);
        }
      },
      onOpen: () => {
        delete errors.file;
      },
      onClose: () => {},
    };

    client.picker(options).open();
  };

  return (
    <div className="file-selector-container">
      <Text fw={600} size="sm">
        If you have one, upload a trip file or itinerary:
      </Text>
      <div className="file-drop-zone">
        <div className="upload-icon-wrapper">
          <Upload
            onClick={handleOpenPicker}
            style={{ color: theme.colors.primary[6] }}
            stroke={1.5}
            width={30}
            height={30}
          />
        </div>
        <label>
          <div className="_attach" onClick={handleOpenPicker}>
            Attach a file or
          </div>{" "}
          drag one here.
        </label>
        <p>Example file types: PDF, JPG, CSV</p>
      </div>
    </div>
  );
};

export default FileSelector;
